// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-wmSD","logo":"styles_logo__EzoC4","error404":"styles_error404__JFLIG","text":"styles_text__Lq2Qp","btn":"styles_btn__UVqXW"};